import * as actionTypes from '../actions/actionTypes';
import * as constants from '../../constants';

import { updateState } from '../../lib/StateHelper';

const initialState = {
  lookupCategory: null,
  lookupCategories: null,
  isNew: false,
  lastState: null,
  lastScope: null
};

const lookupCategoryReducer = (state = initialState, action) => {
  switch(action.type) {
    case actionTypes.LOOKUPCATEGORY_START: {
      return updateState(state, { ...action.data, lastState: constants.STATE_PROCESSING });
    }
    case actionTypes.LOOKUPCATEGORY_SUCCESS: {
      return updateState(state, { ...action.data, lastState: constants.STATE_SUCCESS });
    }
    case actionTypes.LOOKUPCATEGORY_FAIL: {
      return updateState(state, { lastState: constants.STATE_FAIL });
    }
    default: {
      return state;
    }
  }
};

export default lookupCategoryReducer;
